import React, { createContext, useContext, useState, useEffect } from 'react';
import { adminService } from '../services/api';

const AdminContext = createContext();

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within AdminProvider');
  }
  return context;
};

export const AdminProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if admin is logged in
    const token = localStorage.getItem('adminToken');
    if (token) {
      verifyAdmin();
    } else {
      setLoading(false);
    }
  }, []);

  const verifyAdmin = async () => {
    try {
      const response = await adminService.verify();
      if (response.data.valid) {
        setAdmin(response.data.user);
      } else {
        localStorage.removeItem('adminToken');
      }
    } catch (error) {
      console.error('Admin verification failed:', error);
      localStorage.removeItem('adminToken');
    } finally {
      setLoading(false);
    }
  };

  const login = async (credentials) => {
    try {
      const response = await adminService.login(credentials);
      if (response.data.success) {
        localStorage.setItem('adminToken', response.data.token);
        setAdmin(response.data.user);
        return { success: true };
      }
      return { success: false, message: response.data.message };
    } catch (error) {
      return { 
        success: false, 
        message: error.response?.data?.detail || '登入失敗，請檢查您的帳號密碼' 
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    setAdmin(null);
  };

  const value = {
    admin,
    loading,
    login,
    logout,
    isAuthenticated: !!admin
  };

  return <AdminContext.Provider value={value}>{children}</AdminContext.Provider>;
};
